export default "__VITE_ASSET__B7Uapk03__"